// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1LTVW","upload":"Small_upload__faREP","imageWrap":"Small_imageWrap__3T7Bj","removeBtn":"Small_removeBtn__3pgq4"};